import {
  SerializedAdminSetFullnodeUrl,
  SerializedSuiSignAndExecuteTransactionBlockInput,
  SerializedSuiSignPersonalMessageInput,
  SerializedSuiSignTransactionBlockInput,
  SerializedWalletAccount,
  __privateAdd,
  __privateGet,
  __privateSet,
  __publicField,
  deserializeSuiSignAndExecuteTransactionBlockInput,
  deserializeSuiSignMessageInput,
  deserializeSuiSignTransactionBlockInput,
  deserializeWalletAccount,
  is,
  serializeSuiSignAndExecuteTransactionBlockInput,
  serializeSuiSignMessageInput,
  serializeSuiSignTransactionBlockInput,
  serializeWalletAccount,
  validate
} from "./chunk-SHMCLX4J.mjs";

// src/index.ts
import {
  ReadonlyWalletAccount,
  SUI_CHAINS,
  getWallets
} from "@mysten/wallet-standard";

// src/icon.ts
var ICON = "data:image/svg+xml;base64,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";

// src/errors.ts
var _InvalidParamsError = class _InvalidParamsError extends Error {
  constructor(message) {
    super(`${_InvalidParamsError.type}: ${message}}`);
    __publicField(this, "type", _InvalidParamsError.type);
  }
  static asSimpleError(message) {
    return new Error(`${_InvalidParamsError.type}: ${message}`);
  }
  static isSimpleErrorMessage(message) {
    return message.startsWith(_InvalidParamsError.type + ": ");
  }
  static fromSimpleErrorMessage(message) {
    return new _InvalidParamsError(message.slice(_InvalidParamsError.type.length + 2));
  }
};
__publicField(_InvalidParamsError, "type", "INVALID_REQUEST_PARAMS");
var InvalidParamsError = _InvalidParamsError;
var _UserRejectionError = class _UserRejectionError extends Error {
  constructor() {
    super(_UserRejectionError.type);
    __publicField(this, "type", _UserRejectionError.type);
  }
  static asSimpleError() {
    return new Error(_UserRejectionError.type);
  }
  static isSimpleErrorMessage(message) {
    return message === _UserRejectionError.type;
  }
};
__publicField(_UserRejectionError, "type", "USER_REJECTION");
var UserRejectionError = _UserRejectionError;
var _InvalidRequestMethodError = class _InvalidRequestMethodError extends Error {
  constructor(method) {
    super(`${_InvalidRequestMethodError.type}: ${method}`);
    __publicField(this, "type", _InvalidRequestMethodError.type);
  }
  static asSimpleError(method) {
    return new Error(`${_InvalidRequestMethodError.type}: ${method}`);
  }
  static isSimpleErrorMessage(message) {
    return message.startsWith(_InvalidRequestMethodError.type + ": ");
  }
  static fromSimpleErrorMessage(message) {
    return new _InvalidRequestMethodError(message.slice(_InvalidRequestMethodError.type.length + 2));
  }
};
__publicField(_InvalidRequestMethodError, "type", "INVALID_REQUEST_METHOD");
var InvalidRequestMethodError = _InvalidRequestMethodError;
var _DryRunFailedError = class _DryRunFailedError extends Error {
  constructor(message) {
    let msg = _DryRunFailedError.type;
    if (message) {
      msg += ": " + message;
    }
    super(msg);
    __publicField(this, "type", _DryRunFailedError.type);
  }
  static asSimpleError(message) {
    let msg = _DryRunFailedError.type;
    if (message) {
      msg += ": " + message;
    }
    return new Error(msg);
  }
  static isSimpleErrorMessage(message) {
    return message.startsWith(_DryRunFailedError.type);
  }
  static fromSimpleErrorMessage(message) {
    return new _DryRunFailedError(message.slice(_DryRunFailedError.type.length + 2));
  }
};
__publicField(_DryRunFailedError, "type", "DRY_RUN_FAILED");
var DryRunFailedError = _DryRunFailedError;
var _NonAdminOrigin = class _NonAdminOrigin extends Error {
  constructor() {
    super(_NonAdminOrigin.type);
    __publicField(this, "type", UserRejectionError.type);
  }
  static asSimpleError() {
    return new Error(_NonAdminOrigin.type);
  }
  static isSimpleErrorMessage(message) {
    return message === _NonAdminOrigin.type;
  }
};
__publicField(_NonAdminOrigin, "type", "NON_ADMIN_ORIGIN");
var NonAdminOrigin = _NonAdminOrigin;
function isMetaMaskError(obj) {
  return typeof obj === "object" && obj !== null && "message" in obj;
}
function convertError(error) {
  if (!isMetaMaskError(error)) {
    return error;
  }
  if (InvalidParamsError.isSimpleErrorMessage(error.message)) {
    return InvalidParamsError.fromSimpleErrorMessage(error.message);
  } else if (UserRejectionError.isSimpleErrorMessage(error.message)) {
    return new UserRejectionError();
  } else if (InvalidRequestMethodError.isSimpleErrorMessage(error.message)) {
    return InvalidRequestMethodError.fromSimpleErrorMessage(error.message);
  } else if (DryRunFailedError.isSimpleErrorMessage(error.message)) {
    return DryRunFailedError.fromSimpleErrorMessage(error.message);
  } else if (NonAdminOrigin.isSimpleErrorMessage(error.message)) {
    return new NonAdminOrigin();
  }
  return error;
}

// src/index.ts
var SNAP_ORIGIN = "npm:@kunalabs-io/sui-metamask-snap";
var SNAP_VERSION = "^1.0.0";
function registerSuiSnapWallet() {
  const wallets = getWallets();
  for (const wallet2 of wallets.get()) {
    if (wallet2.name === SuiSnapWallet.NAME) {
      console.warn("SuiSnapWallet already registered");
      return wallet2;
    }
  }
  const wallet = new SuiSnapWallet();
  wallets.register(wallet);
  return wallet;
}
async function getAccounts(provider) {
  const res = await provider.request({
    method: "wallet_invokeSnap",
    params: {
      snapId: SNAP_ORIGIN,
      request: {
        method: "getAccounts"
      }
    }
  });
  return res.map((acc) => new ReadonlyWalletAccount(deserializeWalletAccount(acc)));
}
async function admin_getStoredState(provider) {
  const res = await provider.request({
    method: "wallet_invokeSnap",
    params: {
      snapId: SNAP_ORIGIN,
      request: {
        method: "admin_getStoredState"
      }
    }
  });
  return res;
}
async function admin_setFullnodeUrl(provider, network, url) {
  const params = {
    network,
    url
  };
  await provider.request({
    method: "wallet_invokeSnap",
    params: {
      snapId: SNAP_ORIGIN,
      request: {
        method: "admin_setFullnodeUrl",
        params: JSON.parse(JSON.stringify(params))
      }
    }
  });
}
async function signPersonalMessage(provider, messageInput) {
  const serialized = serializeSuiSignMessageInput(messageInput);
  try {
    return await provider.request({
      method: "wallet_invokeSnap",
      params: {
        snapId: SNAP_ORIGIN,
        request: {
          method: "signPersonalMessage",
          params: JSON.parse(JSON.stringify(serialized))
        }
      }
    });
  } catch (e) {
    throw convertError(e);
  }
}
async function signMessage(provider, messageInput) {
  const res = await signPersonalMessage(provider, messageInput);
  return {
    messageBytes: res.bytes,
    signature: res.signature
  };
}
async function signTransactionBlock(provider, transactionInput) {
  const serialized = serializeSuiSignTransactionBlockInput(transactionInput);
  try {
    return await provider.request({
      method: "wallet_invokeSnap",
      params: {
        snapId: SNAP_ORIGIN,
        request: {
          method: "signTransactionBlock",
          params: JSON.parse(JSON.stringify(serialized))
        }
      }
    });
  } catch (e) {
    throw convertError(e);
  }
}
async function signAndExecuteTransactionBlock(provider, transactionInput) {
  const serialized = serializeSuiSignAndExecuteTransactionBlockInput(transactionInput);
  try {
    return await provider.request({
      method: "wallet_invokeSnap",
      params: {
        snapId: SNAP_ORIGIN,
        request: {
          method: "signAndExecuteTransactionBlock",
          params: JSON.parse(JSON.stringify(serialized))
        }
      }
    });
  } catch (e) {
    throw convertError(e);
  }
}
async function metaMaskAvailable() {
  const provider = window.ethereum;
  if (!provider) {
    return {
      available: false,
      supportsSnaps: false,
      suiSnapInstalled: false
    };
  }
  if (!provider.isMetaMask) {
    return {
      available: false,
      suiSnapInstalled: false,
      supportsSnaps: false
    };
  }
  try {
    const version = await provider.request({ method: "web3_clientVersion" });
    const snaps = await provider.request({ method: "wallet_getSnaps" });
    const suiSnapInstalled = !!snaps && "npm:@kunalabs-io/sui-metamask-snap" in snaps;
    return {
      available: true,
      version,
      supportsSnaps: true,
      suiSnapInstalled
    };
  } catch (e) {
    console.warn(e);
    return {
      available: true,
      supportsSnaps: false,
      suiSnapInstalled: false
    };
  }
}
var _connecting, _connected, _accounts, _connect, _disconnect, _signPersonalMessage, _signMessage, _signTransactionBlock, _signAndExecuteTransactionBlock;
var _SuiSnapWallet = class _SuiSnapWallet {
  constructor() {
    __privateAdd(this, _connecting, void 0);
    __privateAdd(this, _connected, void 0);
    __privateAdd(this, _accounts, null);
    __privateAdd(this, _connect, async () => {
      if (__privateGet(this, _connecting)) {
        throw new Error("Already connecting");
      }
      __privateSet(this, _connecting, true);
      __privateSet(this, _connected, false);
      try {
        const provider = window.ethereum;
        const mmStatus = await metaMaskAvailable();
        if (!mmStatus.available) {
          throw new Error("MetaMask not detected!");
        }
        await provider.request({
          method: "wallet_requestSnaps",
          params: {
            [SNAP_ORIGIN]: {
              version: SNAP_VERSION
            }
          }
        });
        __privateSet(this, _accounts, await getAccounts(provider));
        __privateSet(this, _connecting, false);
        __privateSet(this, _connected, true);
        return {
          accounts: this.accounts
        };
      } catch (e) {
        __privateSet(this, _connecting, false);
        __privateSet(this, _connected, false);
        throw e;
      }
    });
    __privateAdd(this, _disconnect, async () => {
      __privateSet(this, _connecting, false);
      __privateSet(this, _connected, false);
      __privateSet(this, _accounts, null);
    });
    __privateAdd(this, _signPersonalMessage, async (messageInput) => signPersonalMessage(window.ethereum, messageInput));
    __privateAdd(this, _signMessage, async (messageInput) => signMessage(window.ethereum, messageInput));
    __privateAdd(this, _signTransactionBlock, async (transactionInput) => signTransactionBlock(window.ethereum, transactionInput));
    __privateAdd(this, _signAndExecuteTransactionBlock, async (transactionInput) => signAndExecuteTransactionBlock(window.ethereum, transactionInput));
    __privateSet(this, _connecting, false);
    __privateSet(this, _connected, false);
  }
  get version() {
    return "1.0.0";
  }
  get name() {
    return _SuiSnapWallet.NAME;
  }
  get icon() {
    return ICON;
  }
  get chains() {
    return SUI_CHAINS;
  }
  get connecting() {
    return __privateGet(this, _connecting);
  }
  get accounts() {
    if (__privateGet(this, _connected) && __privateGet(this, _accounts)) {
      return __privateGet(this, _accounts);
    } else {
      return [];
    }
  }
  get features() {
    return {
      "standard:connect": {
        version: "1.0.0",
        connect: __privateGet(this, _connect)
      },
      "standard:disconnect": {
        version: "1.0.0",
        disconnect: __privateGet(this, _disconnect)
      },
      "sui:signPersonalMessage": {
        version: "1.0.0",
        signPersonalMessage: __privateGet(this, _signPersonalMessage)
      },
      "sui:signMessage": {
        version: "1.0.0",
        signMessage: __privateGet(this, _signMessage)
      },
      "sui:signTransactionBlock": {
        version: "1.0.0",
        signTransactionBlock: __privateGet(this, _signTransactionBlock)
      },
      "sui:signAndExecuteTransactionBlock": {
        version: "1.0.0",
        signAndExecuteTransactionBlock: __privateGet(this, _signAndExecuteTransactionBlock)
      },
      "standard:events": {
        version: "1.0.0",
        on: () => {
          return () => {
          };
        }
      }
    };
  }
};
_connecting = new WeakMap();
_connected = new WeakMap();
_accounts = new WeakMap();
_connect = new WeakMap();
_disconnect = new WeakMap();
_signPersonalMessage = new WeakMap();
_signMessage = new WeakMap();
_signTransactionBlock = new WeakMap();
_signAndExecuteTransactionBlock = new WeakMap();
__publicField(_SuiSnapWallet, "NAME", "Sui MetaMask Snap");
var SuiSnapWallet = _SuiSnapWallet;
export {
  DryRunFailedError,
  InvalidParamsError,
  InvalidRequestMethodError,
  NonAdminOrigin,
  SNAP_ORIGIN,
  SNAP_VERSION,
  SerializedAdminSetFullnodeUrl,
  SerializedSuiSignAndExecuteTransactionBlockInput,
  SerializedSuiSignPersonalMessageInput,
  SerializedSuiSignTransactionBlockInput,
  SerializedWalletAccount,
  SuiSnapWallet,
  UserRejectionError,
  admin_getStoredState,
  admin_setFullnodeUrl,
  convertError,
  deserializeSuiSignAndExecuteTransactionBlockInput,
  deserializeSuiSignMessageInput,
  deserializeSuiSignTransactionBlockInput,
  deserializeWalletAccount,
  getAccounts,
  is,
  metaMaskAvailable,
  registerSuiSnapWallet,
  serializeSuiSignAndExecuteTransactionBlockInput,
  serializeSuiSignMessageInput,
  serializeSuiSignTransactionBlockInput,
  serializeWalletAccount,
  signAndExecuteTransactionBlock,
  signMessage,
  signPersonalMessage,
  signTransactionBlock,
  validate
};
//# sourceMappingURL=index.mjs.map